import React, { useCallback, useEffect, useState } from 'react';
import {
  ApplicationHeader as FidesApplicationHeader,
  axiosInstance,
  useAuthStore,
  useConfigStore,
  UsersMenuRoute,
  TokenRefreshProvider
} from "@fides/fides-react-components";
import { API_ENDPOINTS } from '../../constants/ApiEndpoints';
import { useTranslation } from 'react-i18next';
import useApi from '../../api/useApi';
import { checkIfAnyFidesAdmin } from "../../api/helper";
import { AppRoute } from "../../types/AppRoute";

const appVersion = process.env.REACT_APP_VERSION;
const buildNumber = process.env.REACT_APP_BUILD_NUMBER;

const ApplicationHeader = () => {
  const user = useAuthStore(state => state.user);
  const { t } = useTranslation();
  const isUserLoggedIn = useAuthStore(state => state.userIsLoggedIn);
  const portalUrl = useConfigStore.getState().portalUrl;
  const [portalFrontendUrl, setPortalFrontendUrl] = useState('');

  const [{ data: backendVersion }] = useApi<any>(API_ENDPOINTS.version);

  const [appRoutes, setAppRoutes] = useState<Array<AppRoute> | null>(null);

  const getApplications = useCallback(() => {
    axiosInstance
      .request<any>({
        url: portalUrl + API_ENDPOINTS.fidesPortal.applications,
        method: 'POST',
      })
      .then((response) => {
        setAppRoutes(response.data);
        const routes: AppRoute[] = response.data;
        const url = routes?.find(route => route.name === 'FidesPortal')?.url;
        if (url) {
          setPortalFrontendUrl(`${url}/app`);
        }
      })
  }, [portalUrl]);

  // Do not display current application and if there is only one route (portal), filter it too!
  const filterRoutes = (routes: Array<AppRoute> | null) => {
    const filteredRoutes = routes ? routes.filter(route => route.name !== 'DLCweb') : [];

    return filteredRoutes.length > 1 ? filteredRoutes : [];
  }

  useEffect(() => {
    if (!!portalUrl && isUserLoggedIn) {
      getApplications();
    }
  }, [portalUrl, getApplications, isUserLoggedIn]);

  const isAnyFidesAdmin = checkIfAnyFidesAdmin(user);

  const getUserMenuTypes = (isAnyFidesAdmin: boolean): UsersMenuRoute[] => {
    const userMenuTypes = [
      {
        name: t("generic.personalSetting"),
        url: `${portalFrontendUrl}/user/settings`
      },
      {
        name: t("generic.changePassword"),
        url: `${portalFrontendUrl}/user/change-password`
      },
      {
        name: t("generic.logout"),
        url: `${portalFrontendUrl}/logout`
      }
    ];

    if (isAnyFidesAdmin) {
      userMenuTypes.shift();
    }

    return userMenuTypes;
  };

  return (
    <>
      <TokenRefreshProvider portalUrl={portalFrontendUrl} />
      <FidesApplicationHeader
        appName='Download Center'
        appVersion={appVersion ?? ''}
        buildNumber={`Frontend:${buildNumber} Backend:${backendVersion?.build}`}
        symbolVersion='csIcon'
        navRoutes={[]}
        menuOptions={{
          appRoutes: filterRoutes(appRoutes),
          showApplicationsMenu: true,
          user: user ? { username: user?.username, userDisplayName: `${user?.domainUser.fullName}`, } : undefined,
          showUserMenu: true,
          showDownloadCenterMenu: false,
          userMenuRoutes: getUserMenuTypes(isAnyFidesAdmin),
        }}
      />
    </>
  );
};

export default ApplicationHeader;